import { CommonStore } from "../stores";
import * as Sentry from "@sentry/react";

export const fetchWrapper = (input: string | Request, init: RequestInit, commonStore: CommonStore, showOverlay = true, overlayMessage = 'Загрузка...') => {
    const startTime = new Date();

    if (showOverlay)
        commonStore.showOverlay(overlayMessage, 150);

    init.headers = { ...init.headers, Authorization: `Bearer ${commonStore._rootStore.authStore.token}` };


    return new Promise<Response>((resolve, reject) => {
        fetch(input, init).then((result) => {
            if (!result.ok) {

                result.text().then((resultBody: string) => {
                    const scope = new Sentry.Scope();
                    scope.setTag("fetchStatus", result.status);
                    Sentry.captureMessage(`Fetch error\r\n${resultBody}`, scope);

                    if (result.status === 401 || result.status === 403)
                        commonStore.notifyError("Доступ запрещен")
                    else
                        commonStore.notifyError(`Ошибка при обработке запроса. [${resultBody}]`)

                    reject(new Error(`HTTP ${result.status}: ${resultBody}`));
                })


                return;
            }
            resolve(result);
        }).catch((result: Error) => {
            const scope = new Sentry.Scope();
            Sentry.captureMessage(`Fetch error\r\n${result.message}`, scope);

            reject(result);

        }).finally(() => {
            if (showOverlay) {
                const diff = new Date().getTime() - startTime.getTime();
                commonStore.hideOverlay(diff < 150 ? 0 : diff > 250 ? 0 : 100); //Если выполнилось за 150-250 секунд, то делаем задержку на закрытие в 100мс, чтобы оверлей не мелькал. 
            }
        });
    })

}